//catagory component
import React, { useEffect, useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import CategoryService from '../services/category.service';
import Form from 'react-bootstrap/Form';
import AnimateHeight from 'react-animate-height';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import LogoButton from './LogoButton';


const CategoryList = (props) => {
    const [categories, setCategories] = useState([]);
    const [allChecks, setAllChecks] = useState([]);
    const [isExpanded, setIsExpanded] = useState(false);
    const [height, setHeight] = useState(0);
    const [localCategories, setLocalCategories] = useState([]);


    const toggleExpansion = () => {
        setIsExpanded(!isExpanded);
        setHeight(isExpanded ? 0 : 'auto');
    };

    useEffect(() => {
        const fetchData = async () => {
            // fetch categories
            const categories = await CategoryService.getIgniteCategories();
            setCategories(categories);
            var newChecks = [];
            let value = false;
            for (let i = 0; i < categories.length; i++) {
                value = false;
                if(props.style) {
                for (let j = 0; j < props.style.ignite_categories.length; j++) {
                    if (categories[i].id == props.style.ignite_categories[j].id) {
                        value = true;
                    }
                }
                }
                newChecks.push(value);
            }
            setAllChecks(newChecks);


        }
        if (props.editEnabled) {
            fetchData();
        }
        if(props.style)
            setLocalCategories(props.style.ignite_categories);

    }, [props.editEnabled]);



    const updateCategory = async (e, idx, category) => {
        props.updateIgniteCategoryForStyle(category.id, e.target.checked);
        var newChecks = [...allChecks];
        newChecks[idx] = !newChecks[idx];
        setAllChecks(newChecks);
        var newCategories = [...localCategories];

        if (e.target.checked) {
            newCategories.push(category);
        } else {
            for (let i = 0; i < newCategories.length; i++) {
                if (newCategories[i].id === category.id) {
                    newCategories.splice(i, 1);
                    break;
                }
            }
        }
        setLocalCategories(newCategories);
        console.log("LOCAL CATEGORIES", newCategories);
    }

    return (
        <div>
            <div style={{ margin: 0, padding: 0 }}><span className="sectionTitle">CATEGORIES</span>
                {props.editEnabled ? (
                    <>
                        {isExpanded ?
                            <LogoButton style={{ color: "blue" }} size="20" Icon={ChevronUp} tooltip="Hide Categories" onClick={toggleExpansion} /> :
                            <LogoButton style={{ color: "blue" }} size="20" Icon={ChevronDown} tooltip="Expand Categories" onClick={toggleExpansion} />
                        }
                    </>
                ) : null}
            </div>
            <Row>
                <Col>
                    <ul>
                        {localCategories.map((category) => (
                            <li key={category.id}>{category.categoryName}</li>
                        ))}
                    </ul>
                </Col>
            </Row>
            <AnimateHeight duration={500} height={height}>
                <Row style={{ border: "1px solid #CCCCCC" }}>
                    <Col>
                        {categories.map((category, index) => {
                            if(props.style)
                                for (let i = 0; i < props.style.ignite_categories.length; i++) {
                                    if (category.id === props.style.ignite_categories[i].id) {

                                        break;
                                    }
                                }
                            return (
                                <Form.Group key={category.id} className="mb-3" controlId={`category-${category.id}`}>
                                    <Form.Check
                                        type="checkbox"
                                        label={category.categoryName}
                                        checked={allChecks[index]}
                                        onClick={(e) => updateCategory(e, index, category)}
                                    // Add logic to handle checked state
                                    />
                                </Form.Group>
                            );
                        }

                        )}
                    </Col>
                </Row>
            </AnimateHeight>
        </div>
    );
};
export default CategoryList;
